import React, { FC, MouseEventHandler, ReactNode } from 'react';
import classNames from 'classnames';

import { Button, ButtonIntent } from 'app/design-system/components/Button';

import styles from './EmptyState.module.scss';

type EmptyStateProps = {
  image: ReactNode;
  title: string;
  description: string;
  buttonText?: string;
  onButtonClick?: MouseEventHandler;
  className?: string;
};

export const EmptyState: FC<EmptyStateProps> = ({
  image,
  title,
  description,
  buttonText,
  onButtonClick,
  className,
}) => {
  const _containerClassName = classNames(
    styles.container,
    className,
  );

  return (
    <div className={_containerClassName}
         data-test="empty-state">
      {image}
      <h3>{title}</h3>
      <p>{description}</p>
      {buttonText && onButtonClick && (
        <Button intent={ButtonIntent.CALL_TO_ACTION}
                onClick={onButtonClick}
                className={styles.redirectBtn} >
          {buttonText}
        </Button>
      )}
    </div>
  );
};
